import { createApp } from 'vue'
import Vant from 'vant';

import App from './App.vue'
import router from './router';
import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
import '@/assets/css/iconfont.css'
import '@/assets/css/iconfont01.css'
import '@/assets/css/iconfont02.css'
import '@/assets/css/iconfont03.css'
/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import 'vant/lib/index.css';

import '@/assets/css/common.css'

const app = createApp(App)
    .use(Vant)
    .use(IonicVue)
    .use(router)

app.config.globalProperties.$goBack = function () {
    this.$router.go(-1)
}

app.config.globalProperties.$wescoket = {
    ws: null
};

app.provide('$wescoket', null)
router.isReady().then(() => {
    app.mount('#app');
});
